/**
 * M12 — Badge Probono / Pro-Equity. No pinta nada para FACTURABLE (el caso
 * normal no necesita ruido visual). Labels desde enums:OpportunityBillingMode.
 */

import { useTranslation } from 'react-i18next'
import type { OpportunityBillingMode } from '@toga/shared'

const STYLES: Record<Exclude<OpportunityBillingMode, 'FACTURABLE'>, string> = {
  PROBONO: 'bg-teal-500/10 border-teal-500/40 text-teal-800 dark:text-teal-200',
  PRO_EQUITY: 'bg-violet-500/10 border-violet-500/40 text-violet-800 dark:text-violet-200',
}

export default function BillingModeBadge({
  mode,
  className = '',
}: {
  mode: OpportunityBillingMode | null | undefined
  className?: string
}) {
  const { t } = useTranslation('enums')
  if (!mode || mode === 'FACTURABLE') return null
  return (
    <span
      className={[
        'inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide border whitespace-nowrap',
        STYLES[mode],
        className,
      ].join(' ')}
    >
      {t(`OpportunityBillingMode.${mode}`)}
    </span>
  )
}
